import React from "react";
import axios from "axios";
import useQueryString from "use-query-string";
import { useLocation } from "react-router-dom";

import Loading from "../../Components/Loading";

import { Container, Header } from "./styles";

function ChangePassword() {
  const location = useLocation();
  const [password, setPassword] = React.useState("");
  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const [{ key }] = useQueryString(location);

  if (!key) window.location.href = "/#/";

  React.useEffect(() => {
    if (!passwordConfirm) {
      setError(null);
      return;
    }

    if (passwordConfirm !== password) {
      setError("A confirmação da senha é diferente");
    } else {
      setError(null);
    }
  }, [passwordConfirm, password]);

  function handleSubmit(ev) {
    ev.preventDefault();
    if (password.length < 6) {
      setError("A senha precisa ter ao menos 6 caracteres");
      return;
    }
    if (passwordConfirm !== password) {
      setError("A confirmação da senha é diferente");
      return;
    }

    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/change-password`, {
        hash: key,
        newPassword: password,
      })
      .then(({ data }) => {
        alert("Senha alterada com sucesso!");
        window.location.href = "/#/";
      })
      .catch((err) => {
        alert("Não foi possível alterar a senha!");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Container>
      <Header>
        <h1>Alteração da senha de acesso ao Portal Mindi</h1>
      </Header>
      <form>
        <input
          onChange={(ev) => setPassword(ev.target.value)}
          value={password}
          placeholder="Digite a nova senha"
        />
        <input
          onChange={(ev) => setPasswordConfirm(ev.target.value)}
          value={passwordConfirm}
          placeholder="Confirme a nova senha"
        />
        {!!error && (
          <div style={{ color: "red" }}>
            <small>{error}</small>
          </div>
        )}
        <button onClick={handleSubmit}>Criar nova senha</button>
        {loading && <Loading />}
      </form>
    </Container>
  );
}

export default ChangePassword;
